import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyYen: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="currency-yen, money"><path d="M5.75 3.75L12 10.9688M12 10.9688L18.25 3.75M12 10.9688V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 14.75H17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 11.75H17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCurrencyYen;
